/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LabelType {
  Core = 'Core',
  Outer = 'Outer',
  Pack = 'Pack',
  ReelOuter = 'ReelOuter',
  Tray = 'Tray'
}
